import request from "@/utils/request";

export default {
    // 查询工厂和供应商信息
    findMyPlantListPage: (params) => {
        return request({
            url: "/settlementUnit/findMyPlantListPage",
            method: "post",
            data: params
        })
    },
    // 下载导入模板
    downloadImportTemplate: (id) => {
        return request({
            url: "/process/record/downloadTemplate/" + id,
            method: "get",
            responseType: "blob",
            fullResponse: true
        })
    },
    // 导入模板数据
    importTemplateData: (tplId, params) => {
        return request({
            url: "/process/record/import/" + tplId,
            method: "post",
            headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
            },
            data: params
        })
    },
    // 小批次记录列表
    getProcessRecordPage: (params) => {
        return request({
            url: "/process/record/list/s",
            method: "post",
            data: params
        });
    },
    // 大批次记录列表
    getLargeProcessRecordPage: (params) => {
        return request({
            url: "/process/record/list/l",
            method: "post",
            data: params
        });
    },
    // 作废小批次
    doVoid: (params) => {
        return request({
            url: "/process/record/drop/s",
            method: "post",
            data: params
        })
    },
    // 作废大批次
    doVoidLarge: (params) => {
        return request({
            url: "/process/record/drop/l",
            method: "post",
            data: params
        })
    },
    // 删除小批次
    doDelete: (params) => {
        return request({
            url: "/process/record/delete/s",
            method: "post",
            data: params
        })
    },
    // 批量提交小批次
    batchSubmit: (params) => {
        return request({
            url: "/process/record/submit/batch/s",
            method: "post",
            data: params
        })
    },
    // 批量提交大批次
    batchSubmitLarge: (params) => {
        return request({
            url: "/process/record/submit/batch/l",
            method: "post",
            data: params
        })
    },
    // 导出数据
    exportList: (params) => {
        return request({
            url: "/process/record/export",
            method: "post",
            data: params,
            responseType: "blob",
            fullResponse: true
        })
    },
    // 模板列表
    getProcessTemplateList: (params) => {
        return request({
            url: "/processTemplate/processTemplateList",
            method: "post",
            data: params
        })
    },
    // 创建小批次获取初始数据
    getProcessInitData: (params) => {
        return request({
            url: "/process/record/initialize/s",
            method: "post",
            data: params
        })
    },
    // 保存小批次记录
    saveProcessRecord: (params) => {
        return request({
            url: "/process/record/save/s",
            method: "post",
            data: params
        })
    },
    // 保存大批次
    saveLargeProcessRecord: (params) => {
        return request({
            url: "/process/record/save/l",
            method: "post",
            data: params
        })
    },
    // 提交小批次记录
    submitProcessRecord: (params) => {
        return request({
            url: "/process/record/submit/s",
            method: "post",
            data: params
        })
    },
    // 提交大批次
    submitLargeProcessRecord: (params) => {
        return request({
            url: "/process/record/submit/l",
            method: "post",
            data: params
        })
    },
    // 模板信息
    getProcessRecordTemplate: (params) => {
        return request({
            url: "/process/record/tpl",
            method: "get",
            params: params
        })
    },
    // 记录详情
    getProcessRecordTemplateDetail: (params) => {
        return request({
            url: "/process/record/detail",
            method: "get",
            params: params
        })
    },
    // 操作日志
    getOperationLog: (params) => {
        return request({
            url: "/process/record/operationLog",
            method: "get",
            params: params
        })
    },


    // 制成数据分布图
    getProcessDataDistribution: (params) => {
        return request({
            url: "/process/record/dataDistChart",
            method: "post",
            data: params
        })
    },
    // 导出制成数据分布图
    exportProcessDataDistribution: (params) => {
        return request({
            url: "/process/record/dataDistChart/export",
            method: "post",
            data: params,
            responseType: "blob",
            fullResponse: true
        })
    },
    // 根据模板ID获取供应商列表
    getSupplierListByTemplateId: (params) => {
        return request({
            url: "/process/record/plants",
            method: "get",
            params: params
        })
    },

}